/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import './style/bluemateExternalLink.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {MouseEventHandler, PropsWithChildren} from 'react';

interface Props {
    href: string;
    label?: string;
    showIcon?: boolean;
    className?: string;
    /** Native tooltip on the anchor (e.g. an icon-only link). */
    title?: string;
    onClick?: MouseEventHandler;
}

export default function BluemateExternalLink(props: PropsWithChildren<Props>) {
    const {href, children, label, showIcon = true, className, title, onClick} = props;

    return (
        <a
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            className={classNames('bluemate-external-link', className)}
            title={title}
            onClick={onClick}
        >
            {children ?? label}
            {showIcon && <Icon icon='mdi:open-in-new' className='bluemate-external-link-icon' />}
        </a>
    );
}
